// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscription-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px; }
  .subscription-page-header .page-title {
    font-size: 24px;
    font-weight: 500;
    color: #ffffff; }
  .subscription-page-header .page-description {
    font-size: 14px;
    font-weight: 400;
    color: #ffffffb2; }

.notice {
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  color: #ffffff; }

.payment-tabs,
.nav-tabs {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 2px solid #397b91;
  position: relative; }
  .payment-tabs .border,
  .nav-tabs .border {
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #397b91;
    transition: 0.3s;
    z-index: 20; }
  .payment-tabs .payment-tab,
  .nav-tabs .payment-tab {
    border: none !important;
    padding: 8px 43px;
    background-image: none !important;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: 0.3s;
    color: white !important;
    border-radius: 12px 12px 0 0; }
    .payment-tabs .payment-tab:hover,
    .nav-tabs .payment-tab:hover {
      background-image: none; }
    .payment-tabs .payment-tab:not(.active),
    .nav-tabs .payment-tab:not(.active) {
      background-color: #253d46; }
  .payment-tabs .active,
  .nav-tabs .active {
    background-color: #397b91; }
  .payment-tabs .payment-tab:nth-child(2),
  .nav-tabs .payment-tab:nth-child(2) {
    margin-left: 12px; }

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  border-bottom: 2px solid #397b91; }

.nav-tabs .nav-link {
  border: none; }

.duration-switch {
  display: flex;
  justify-content: flex-start;
  border: 2px solid #397b91;
  width: fit-content;
  border-radius: 12px; }
  .duration-switch .duration-button {
    padding: 5px 32px;
    border: none;
    color: white;
    font-size: 12px;
    font-weight: 500;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s; }
    .duration-switch .duration-button.active {
      background-color: #397b91; }

.subscription-info-card {
  min-height: 600px;
  border-radius: 15px;
  border: none;
  background: none; }
  .subscription-info-card .card-header {
    background-color: #397b91 !important;
    color: #ffffff;
    margin: 0;
    font-family: "Inter";
    font-weight: 600;
    padding: 25px 35px !important;
    border-radius: 14px 14px 0 0; }
    .subscription-info-card .card-header .description {
      font-size: 14px;
      font-weight: 400;
      color: #ffffff; }
    .subscription-info-card .card-header .row {
      text-align: start; }
  .subscription-info-card .card-body {
    border-left: 2px solid #34575f;
    border-right: 2px solid #34575f;
    background-color: #1e2830;
    color: #ffffff;
    padding: 35px 20px; }
    .subscription-info-card .card-body .price {
      color: #8edef5;
      display: flex;
      align-items: center; }
    .subscription-info-card .card-body .duration {
      font-size: 14px;
      font-weight: 400;
      margin-left: 10px; }
    .subscription-info-card .card-body .included-items {
      font-family: "Inter";
      font-size: 14px;
      font-weight: 400;
      margin: 7.5px 0; }
      .subscription-info-card .card-body .included-items img {
        margin-right: 10px; }
  .subscription-info-card .card-footer {
    background-color: #1e2830;
    border-radius: 0 0 15px 15px;
    border: 2px solid #34575f;
    border-top: none;
    padding: 0px 35px 25px 35px; }
    .subscription-info-card .card-footer .subscribe-button {
      background-color: #397b91;
      color: #ffffff;
      border: none;
      border-radius: 10px;
      padding: 10px 20px;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      width: 100%; }
      .subscription-info-card .card-footer .subscribe-button:hover {
        background-color: #34575f; }

.subscription-table tbody > tr {
  background-color: #232b32 !important; }

.subscription-table .table-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 10px 0; }

.subscription-table .price-type {
  font-size: 14px;
  font-weight: 400;
  color: #ffffff; }

.subscription-table .price-amount {
  font-size: 24px;
  font-weight: 500;
  color: #ffffff; }

.subscription-table .subsection-header {
  font-size: 12px;
  font-weight: 500;
  color: #489efe;
  margin: 10px; }

.subscription-table .subsection-info {
  font-size: 12px;
  font-weight: 400;
  color: #ffffff; }

.subscription-table .info-detail {
  font-size: 12px;
  font-weight: 400;
  color: #ffffff; }

.subscription-table tbody tr:last-child > td {
  padding-bottom: 30px; }

.subscription-table .table-footer {
  background-color: #2a434e; }

.subscription-table .table-footer tr td:last-child {
  border-bottom-right-radius: 15px; }

.subscription-table .table-footer tr td:first-child {
  border-bottom-left-radius: 15px; }

.subscription-table .button-wrapper {
  display: flex;
  justify-content: center;
  padding: 15px 0; }
  .subscription-table .button-wrapper .modal-btn {
    width: 100% !important;
    display: flex;
    justify-content: center; }
  .subscription-table .button-wrapper .subscribe-button {
    background-color: #397b91;
    color: #ffffff;
    border: none;
    border-radius: 10px;
    padding: 8px 20px;
    font-size: 12px;
    font-weight: 400;
    width: 50%;
    text-align: center; }
    .subscription-table .button-wrapper .subscribe-button:hover {
      background-color: #34575f; }
`, "",{"version":3,"sources":["webpack://./src/components/Subscriptions/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB,EAAA;EAJrB;IAMI,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAA;EARlB;IAWI,eAAe;IACf,gBAAgB;IAChB,gBAAgB,EAAA;;AAIpB;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;;EAEE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB,EAAA;EALpB;;IAOI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,WAAW,EAAA;EAdf;;IAiBI,uBAAuB;IACvB,iBAAiB;IACjB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,4BAA4B,EAAA;IAzBhC;;MA2BM,sBAAsB,EAAA;IA3B5B;;MA+BM,yBAAyB,EAAA;EA/B/B;;IAmCI,yBAAyB,EAAA;EAnC7B;;IAwCI,iBAAiB,EAAA;;AAIrB;;EAEE,gCAAgC,EAAA;;AAIlC;EACE,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB,EAAA;EALrB;IAOI,iBAAiB;IACjB,YAAY;IAEZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB,EAAA;IAfpB;MAkBM,yBAAyB,EAAA;;AAK/B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB,EAAA;EAJlB;IAMI,oCAAoC;IACpC,cAAc;IACd,SAAS;IACT,oBAAoB;IACpB,gBAAgB;IAChB,6BAA6B;IAC7B,4BAA4B,EAAA;IAZhC;MAcM,eAAe;MACf,gBAAgB;MAChB,cAAc,EAAA;IAhBpB;MAmBM,iBAAiB,EAAA;EAnBvB;IAyBI,8BAA8B;IAC9B,+BAA+B;IAa/B,yBAAyB;IACzB,cAAc;IACd,kBAAkB,EAAA;IAzCtB;MA4BM,cAAc;MACd,aAAa;MAEb,mBAAmB,EAAA;IA/BzB;MAkCM,eAAe;MACf,gBAAgB;MAEhB,iBAAiB,EAAA;IArCvB;MA4CM,oBAAoB;MACpB,eAAe;MACf,gBAAgB;MAChB,eAAe,EAAA;MA/CrB;QAiDQ,kBAAkB,EAAA;EAjD1B;IAwDI,yBAAyB;IACzB,4BAA4B;IAC5B,yBAAyB;IACzB,gBAAgB;IAChB,2BAA2B,EAAA;IA5D/B;MA+DM,yBAAyB;MACzB,cAAc;MACd,YAAY;MACZ,mBAAmB;MACnB,kBAAkB;MAClB,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,WAAW,EAAA;MAvEjB;QAyEQ,yBAAyB,EAAA;;AAMjC;EAEI,oCAAoC,EAAA;;AAFxC;EAMI,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc,EAAA;;AAVlB;EAaI,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAA;;AAflB;EAkBI,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAA;;AApBlB;EAwBI,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY,EAAA;;AA3BhB;EA8BI,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAA;;AAhClB;EAoCI,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAA;;AAtClB;EA2CM,oBAAoB,EAAA;;AA3C1B;EA+CI,yBAAyB,EAAA;;AA/C7B;EAkDI,gCAAgC,EAAA;;AAlDpC;EAqDI,+BAA+B,EAAA;;AArDnC;EAwDI,aAAa;EACb,uBAAuB;EACvB,eAAe,EAAA;EA1DnB;IA4DM,sBAAsB;IACtB,aAAa;IACb,uBAAuB,EAAA;EA9D7B;IAiEM,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,kBAAkB,EAAA;IAzExB;MA2EQ,yBAAyB,EAAA","sourcesContent":[".subscription-page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  .page-title {\n    font-size: 24px;\n    font-weight: 500;\n    color: #ffffff;\n  }\n  .page-description {\n    font-size: 14px;\n    font-weight: 400;\n    color: #ffffffb2;\n  }\n}\n\n.notice {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 17px;\n  letter-spacing: 0em;\n  text-align: left;\n  color: #ffffff;\n}\n\n.payment-tabs,\n.nav-tabs {\n  display: flex;\n  margin-bottom: 20px;\n  border-bottom: 2px solid #397b91;\n  position: relative;\n  .border {\n    position: absolute;\n    bottom: -2px;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background-color: #397b91;\n    transition: 0.3s;\n    z-index: 20;\n  }\n  .payment-tab {\n    border: none !important;\n    padding: 8px 43px;\n    background-image: none !important;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: 0.3s;\n    color: white !important;\n    border-radius: 12px 12px 0 0;\n    &:hover {\n      background-image: none;\n    }\n\n    &:not(.active) {\n      background-color: #253d46;\n    }\n  }\n  .active {\n    background-color: #397b91;\n  }\n\n  // second tab has margin-left\n  .payment-tab:nth-child(2) {\n    margin-left: 12px;\n  }\n}\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link.active {\n  border-bottom: 2px solid #397b91;\n}\n\n// remove the on click border\n.nav-tabs .nav-link {\n  border: none;\n}\n\n.duration-switch {\n  display: flex;\n  justify-content: flex-start;\n  border: 2px solid #397b91;\n  width: fit-content;\n  border-radius: 12px;\n  .duration-button {\n    padding: 5px 32px;\n    border: none;\n\n    color: white;\n    font-size: 12px;\n    font-weight: 500;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: 0.3s;\n\n    &.active {\n      background-color: #397b91;\n    }\n  }\n}\n\n.subscription-info-card {\n  min-height: 600px;\n  border-radius: 15px;\n  border: none;\n  background: none;\n  .card-header {\n    background-color: #397b91 !important;\n    color: #ffffff;\n    margin: 0;\n    font-family: \"Inter\";\n    font-weight: 600;\n    padding: 25px 35px !important;\n    border-radius: 14px 14px 0 0;\n    .description {\n      font-size: 14px;\n      font-weight: 400;\n      color: #ffffff;\n    }\n    .row {\n      text-align: start;\n    }\n  }\n\n  .card-body {\n    // border only left and right\n    border-left: 2px solid #34575f;\n    border-right: 2px solid #34575f;\n    .price {\n      color: #8edef5;\n      display: flex;\n\n      align-items: center;\n    }\n    .duration {\n      font-size: 14px;\n      font-weight: 400;\n\n      margin-left: 10px;\n    }\n    background-color: #1e2830;\n    color: #ffffff;\n    padding: 35px 20px;\n\n    .included-items {\n      font-family: \"Inter\";\n      font-size: 14px;\n      font-weight: 400;\n      margin: 7.5px 0;\n      img {\n        margin-right: 10px;\n      }\n    }\n  }\n  .card-footer {\n    // border not on top\n\n    background-color: #1e2830;\n    border-radius: 0 0 15px 15px;\n    border: 2px solid #34575f;\n    border-top: none;\n    padding: 0px 35px 25px 35px;\n\n    .subscribe-button {\n      background-color: #397b91;\n      color: #ffffff;\n      border: none;\n      border-radius: 10px;\n      padding: 10px 20px;\n      font-size: 16px;\n      font-weight: 500;\n      text-align: center;\n      width: 100%;\n      &:hover {\n        background-color: #34575f;\n      }\n    }\n  }\n}\n\n.subscription-table {\n  tbody > tr {\n    background-color: #232b32 !important;\n  }\n\n  .table-header {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 10px 0;\n  }\n  .price-type {\n    font-size: 14px;\n    font-weight: 400;\n    color: #ffffff;\n  }\n  .price-amount {\n    font-size: 24px;\n    font-weight: 500;\n    color: #ffffff;\n  }\n\n  .subsection-header {\n    font-size: 12px;\n    font-weight: 500;\n    color: #489efe;\n    margin: 10px;\n  }\n  .subsection-info {\n    font-size: 12px;\n    font-weight: 400;\n    color: #ffffff;\n  }\n\n  .info-detail {\n    font-size: 12px;\n    font-weight: 400;\n    color: #ffffff;\n  }\n  tbody {\n    // last row apply some margin\n    tr:last-child > td {\n      padding-bottom: 30px;\n    }\n  }\n  .table-footer {\n    background-color: #2a434e;\n  }\n  .table-footer tr td:last-child {\n    border-bottom-right-radius: 15px;\n  }\n  .table-footer tr td:first-child {\n    border-bottom-left-radius: 15px;\n  }\n  .button-wrapper {\n    display: flex;\n    justify-content: center;\n    padding: 15px 0;\n    .modal-btn {\n      width: 100% !important;\n      display: flex;\n      justify-content: center;\n    }\n    .subscribe-button {\n      background-color: #397b91;\n      color: #ffffff;\n      border: none;\n      border-radius: 10px;\n      padding: 8px 20px;\n      font-size: 12px;\n      font-weight: 400;\n      width: 50%;\n      text-align: center;\n      &:hover {\n        background-color: #34575f;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
